import { registerVueComponentAndAngularBindings, declareComponents} from '/vodalys/vvuejs'

import PlanTunnel from './PlanTunnel.vue'
registerVueComponentAndAngularBindings('plan:tunnel:page', 'planTunnel', PlanTunnel)

import components from './component/**/*.vue'
declareComponents('components', components)